// Local translations
export const T = {
  en_GB: {
    gateQuestion: "Is sustainability important to you?",
    yes: "Yes",
    no: "No",
    preferencesTitle: "Your sustainability preferences",
    preferencesDescription: "Set the minimum step you require for each criterion.",
    scaleHint: "minimum step you require",
    selectLevel: "Select minimum step",
    productPreferencesTitle: "Product preferences",
    productPreferencesDescription: "Select the product preferences that matter to you.",
    alignmentTitle: "Portfolio alignment",
    alignmentIndividual: "Product",
    alignmentIndividualDescription: "Every instrument must meet the preferences.",
    alignmentPortfolio: "Portfolio",
    alignmentPortfolioDescription: "A weighted share of the portfolio must meet them.",
    thresholdLabel: "Required share of the portfolio",
    selectThreshold: "Select minimum share",
    thresholdOption: (pct: string) => `Minimum ${pct} %`,
    incompleteMessage: "Please complete the sustainability preferences.",
    notConfigured: "Sustainability is not configured for this flow's portfolio collection.",
  },
  nb_NO: {
    gateQuestion: "Er bærekraft viktig for deg?",
    yes: "Ja",
    no: "Nei",
    preferencesTitle: "Dine bærekraftspreferanser",
    preferencesDescription: "Angi minimumstrinnet du krever for hvert kriterium.",
    scaleHint: "minste trinn du krever",
    selectLevel: "Velg minste trinn",
    productPreferencesTitle: "Produktpreferanser",
    productPreferencesDescription: "Velg produktpreferansene som er viktige for deg.",
    alignmentTitle: "Porteføljetilpasning",
    alignmentIndividual: "Produkt",
    alignmentIndividualDescription: "Hvert instrument må oppfylle preferansene.",
    alignmentPortfolio: "Portefølje",
    alignmentPortfolioDescription: "En vektet andel av porteføljen må oppfylle dem.",
    thresholdLabel: "Nødvendig andel av porteføljen",
    selectThreshold: "Velg minste andel",
    thresholdOption: (pct: string) => `Minst ${pct} %`,
    incompleteMessage: "Vennligst fullfør bærekraftspreferansene.",
    notConfigured: "Bærekraft er ikke konfigurert for denne flytens porteføljesamling.",
  },
} as const;
